module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl\"> You have reached the maximum amount of {%- maxDisplay %} boxes. If you need more boxes, please split this into two returns. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fxoReceivingScreen/html/warningModalBodyFor30Box.html
// module id = 292
// module chunks = 1